export const SWITCH_VALUE_TYPE:string = 'story/SWITCH_VALUE_TYPE';
export const CREATE_STORY:string = 'story/CREATE_STORY';
export const CREATE_STORY_COMPLETE: string = 'story/CREATE_STORY_COMPLETE';